import { combineReducers } from 'redux';

import { reducer as ad } from './bundles/ad';
import { reducer as alarms } from './bundles/alarms';
import { reducer as analytics } from './bundles/analytics';
import { reducer as application } from './bundles/application';
import { reducer as auth } from './bundles/auth';
import { reducer as bookmarks } from './bundles/bookmarks';
import { reducer as comments } from './bundles/comments';
import { reducer as components } from './bundles/components';
import { reducer as events } from './bundles/events';
import { reducer as files } from './bundles/files';
import { reducer as geometryMappings } from './bundles/geometry-mappings';
import { reducer as integrations } from './bundles/integrations';
import { reducer as layouts } from './bundles/layouts';
import { reducer as models } from './bundles/models';
import { reducer as notificationConfig } from './bundles/notification-config';
import { reducer as notifications } from './bundles/notifications';
import { reducer as sites } from './bundles/sites';
import { reducer as sources } from './bundles/sources';
import { reducer as statesets } from './bundles/statesets';
import { reducer as systemMessages } from './bundles/systemMessages';
import { reducer as tags } from './bundles/tags';
import { reducer as trails } from './bundles/trails';
import { reducer as types } from './bundles/types';
import { reducer as uploads } from './bundles/uploads';
import { reducer as userSettings } from './bundles/user-settings';
import { reducer as qrCodes } from './bundles/qrCodes';
import { reducer as variables } from './bundles/variables';
import { reducer as visualizations } from './bundles/visualizations';
import { reducer as tfrTemplates } from './bundles/tfr-templates';

const reducers = combineReducers({
  ad,
  alarms,
  analytics,
  application,
  auth,
  bookmarks,
  comments,
  components,
  events,
  files,
  geometryMappings,
  integrations,
  layouts,
  models,
  notificationConfig,
  notifications,
  sites,
  sources,
  statesets,
  systemMessages,
  tags,
  trails,
  types,
  uploads,
  userSettings,
  qrCodes,
  variables,
  visualizations,
  tfrTemplates,
});

export default reducers;
